<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 25 24" fill="none">
    <path d="M16.5996 5.75C15.0573 5.75 13.8515 6.9117 12.7601 8.38742C11.2602 6.47769 10.0059 5.75 8.50478 5.75C5.44444 5.75 3.09961 9.73276 3.09961 13.9482C3.09961 16.5862 4.3758 18.25 6.5134 18.25C8.05191 18.25 9.1584 17.5247 11.1255 14.0862C11.1255 14.0862 11.9454 12.6382 12.5095 11.6407C12.7072 11.9598 12.9149 12.3032 13.1341 12.6724L14.0565 14.2242C15.8533 17.231 16.8545 18.25 18.6686 18.25C20.751 18.25 21.9099 16.5634 21.9099 13.8707C21.9099 9.4569 19.5123 5.75 16.5996 5.75ZM9.62547 13.1552C8.03065 15.6552 7.47892 16.2155 6.59099 16.2155C5.6772 16.2155 5.1341 15.4132 5.1341 13.9827C5.1341 10.9224 6.65995 7.7931 8.47892 7.7931C9.46394 7.7931 10.2871 8.36198 11.5479 10.167C10.3507 12.0034 9.62547 13.1552 9.62547 13.1552ZM15.6446 12.8404L14.5417 11.0011C14.2433 10.5157 13.9573 10.0697 13.6813 9.66072C14.6753 8.12652 15.4952 7.36207 16.4703 7.36207C18.4962 7.36207 20.1168 10.3448 20.1168 14.0086C20.1168 15.4052 19.6594 16.2155 18.7117 16.2155C17.8033 16.2155 17.3693 15.6156 15.6446 12.8404Z" 
    fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'MetaIcon',
  props: {
    width: {
      type: Number,
      default: 24
    },
    height: {
      type: Number,
      default: 24
    }
  }
}
</script>

<style scoped></style>